module.exports = __webpack_public_path__ + "media/images/landing_page/screen_mobile-3e857404d33944cdf5904d8a4eaaa53e.webp";